import React from "react";
import "./TripAI.css";

// Follows DestinationCard.js's pattern (data entirely via props, no
// window.guide_obj/redux coupling), since this renders a place from a GUIDE
// VERSION THAT ISN'T THE ACTIVE ONE (the server's "their version" content
// fetched only for this diff view).
//
// For an added/removed place, pass `place`, `kind` ("added"|"removed"),
// `included` (bool) and `onToggleInclude`. For a changed place, pass `place`
// (the server/new version), `changedFrom` (the local/old version),
// `changedFields` (from GuideDiff.diffPlaces), `fieldChoices` (the current
// per-field "mine"|"theirs" picks) and `onFieldChoice(field, choice)`.
const PlaceDiffCard = ({ place, changedFrom, changedFields, kind, included, onToggleInclude, fieldChoices, onFieldChoice }) => (
  <div className="tai-dest-card">
    <div className="tai-dest-header">
      <span className="tai-dest-title">{place.Name || "(unnamed place)"}</span>
      {(kind === "added" || kind === "removed") && (
        <label className="tai-diff-include">
          <input
            type="checkbox"
            checked={included !== false}
            onChange={(e) => onToggleInclude(e.target.checked)}
          />
          {kind === "added" ? "Include their addition" : "Keep mine"}
        </label>
      )}
    </div>
    {place.Address || place.City || place.Country ? (
      <div className="tai-row-item">
        <span className="tai-row-value">
          {[place.Address, place.City, place.Country].filter(Boolean).join(", ")}
        </span>
      </div>
    ) : null}
    {changedFields && changedFields.length > 0 && (
      <>
        <div className="tai-divider" />
        {changedFields.map((field) => {
          const choice = fieldChoices?.[field];
          return (
            <div className="tai-diff-field" key={field}>
              <div className="tai-diff-field-key">{field}</div>
              <label className="tai-diff-choice">
                <input
                  type="radio"
                  name={`${place.ID}-${field}`}
                  checked={choice === "mine"}
                  onChange={() => onFieldChoice(field, "mine")}
                />{" "}
                Mine: {String(changedFrom?.[field] ?? "")}
              </label>
              <label className="tai-diff-choice">
                <input
                  type="radio"
                  name={`${place.ID}-${field}`}
                  checked={choice === "theirs"}
                  onChange={() => onFieldChoice(field, "theirs")}
                />{" "}
                Theirs: {String(place[field] ?? "")}
              </label>
            </div>
          );
        })}
      </>
    )}
  </div>
);

export default PlaceDiffCard;
